<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item active">{{ module }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-lg-flex align-items-center justify-content-between mb-4">
              <div class="align-items-center d-lg-flex d-none">
                <div class="form-group mb-0 align-items-center d-flex">
                  <label class="mb-0">Show</label>
                  <select class="form-control ml-3" v-model="show" @change="showLimit">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <div class="form-group mb-0 ml-3">
                  <!-- <button type="button" class="btn btn-info" @click="visible = true">Filter & Search</button>-->
                  <button type="button" class="btn btn-info" @click="visible = true">Filter & Search</button>
                </div>
              </div>
              <template v-if="local_users.usr_admin != ''">
              <div class="d-flex align-items-center">
                <button
                  v-if="massData.length > 0"
                  @click="processMassDelete"
                  class="btn btn-danger mr-1"
                  type="button"
                >Delete</button>
                <button
                  class="btn btn-secondary mr-1"
                  :value="table_module"
                  :id="module"
                  @click="this.$root._export"
                  type="button"
                >Export Data</button>
                <div class="dropdown">
                  <button
                    class="btn btn-primary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    + {{module}}
                    <i class="mdi mdi-chevron-down"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <router-link
                      class="dropdown-item right-bar-toggle"
                      :to="{name: table_module+'_create'}"
                    >Create New</router-link>
                    <router-link
                      class="dropdown-item right-bar-toggle"
                      :to="{name: table_module+'_import'}"
                    >Import Data</router-link>
                  </div>
                </div>
              </div>
              </template>
            </div>

            <tables
              :module="module"
              :table_module="table_module"
              :alias_table="alias_table"
              :data="data"
              :fields="fields"
              :local_users="local_users"
              @fetchData="fetchData"
              @massDelete="massDelete"
              @uncheckMassDelete="uncheckMassDelete"
              :sortable="{
                orderBy : orderBy,
                sort : sort,
              }"
            ></tables>
          </div>
        </div>
      </div>
    </div>

    <search
      v-if="visible"
      :visible="visible"
      :fields="fields"
      :table_module="table_module"
      :module="module"
      :alias_table="alias_table"
      @hiddenSideSearch="visible = false"
      @paramSearch="paramSearch"
      @loading="loading"
    ></search>
  </div>
</template>

<script>
import tables from "@/components/tables";
import search from "@/components/search";

export default {
  data() {
    return {
      isLoading: false,
      module: "Brand Products",
      table_module: "brand",
      alias_table: "brd",
      fields: {},
      data: {},
      show: 10,
      page: 1,
      totalData: 0,
      massData: [],
      visible: false,
      dataSearch: {},
      orderBy : 'created_at',
      sort : 'desc',
    };
  },
  components: {
    tables,
    search,
  },
  computed: {
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
  },
  mounted() {
    if (typeof this.$route.query.page !== 'undefined') 
    {
      this.page = this.$route.query.page
    }
    if (typeof this.$route.query.limit !== 'undefined') 
    {
      this.limit = this.$route.query.limit
    }
    if (typeof this.$route.query.orderBy !== 'undefined') 
    {
      this.orderBy = this.$route.query.orderBy
    }
    if (typeof this.$route.query.sort !== 'undefined') 
    {
      this.sort = this.$route.query.sort
    }
    this.fetchData();
  },
  methods: {
    fetchData(arm) {
      this.isLoading = true;
      var params = {};
      if (arm == undefined) {
        params = {
          page: this.page,
          show: this.show,
          order_by: this.orderBy,
          type_sort: this.sort,
        };
      } else {
        params = {
          page: (arm.page == undefined) ? this.page : arm.page,
          show: (arm.show == undefined) ? this.show : arm.show,
          order_by: (arm.orderBy == undefined) ? this.orderBy : arm.orderBy,
          type_sort: (arm.sort == undefined) ? this.sort : arm.sort,
        };
      }

      this.orderBy = params.order_by;
      this.sort = params.type_sort;

      if (this.dataSearch.search != undefined) {
        for (const key in this.dataSearch.search) {
          params["search[" + key + "]"] = this.dataSearch.search[key];
        }
      }

      this.axios
        .get("/" + this.table_module, { params: params })
        .then((response) => {
          this.fields = response.data.data.fields;
          this.data = response.data.data[this.table_module];
          this.isLoading = false;
        });
    },
    showLimit() {
      this.page = 1;
      this.fetchData();
    },
    massDelete(newValue) {
      if (newValue == null) {
        this.massData = [];
      } else {
        this.massData.push(newValue);
      }
    },
    uncheckMassDelete(newValue) {
      var index = this.massData.indexOf(newValue);
      this.massData.splice(index, 1);
    },
    processMassDelete() {
      var Swal = this.$swal;
      Swal.fire({
        title: "Yakin ingin hapus data yang dipilih?",
        // text: "You will not be able to recover this imaginary file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.axios
            .post("/" + this.table_module + "/mass_delete", this.massData)
            .then((response) => {
              if (response.data.status == 200) {
                this.massData = []; // reset mass data
                this.fetchData();
              }
            });
        }
      });
    },
    paramSearch(arm) {
      this.page = 1;
      this.show = 10;
      this.dataSearch = arm;
      this.fetchData();
    },
    loading(arm) {
      if (arm == true) {
        this.fields = {};
        this.data = {};
      }
    },
  },
};
</script>